import React, { useState } from "react";
import {
  Space,
  message,
  Table,
  Button,
  Typography,
  Tabs,
  DatePicker,
} from "antd";
import Util from "../../Util";

const { Title } = Typography;

function Monthly() {
  const [loading, setLoading] = useState(false);
  const [showTables, setShowTables] = useState(false);
  const [selectedDateString, setSelectedDateString] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const [branchTable, setBranchTable] = useState([]);
  const [noVendorTable, setNoVendorTable] = useState([]);
  const [lessHundredTable, setLessHundredTable] = useState([]);
  const [moreHundredTable, setMoreHundredTable] = useState([]);

  const downloadAsCsv = (inpData, inpCol, fileName) => {
    const data = [];
    data.push(inpCol.map((col) => col.title).join(","));
    for (const x of inpData) {
      data.push(inpCol.map((col) => x[col.dataIndex]).join(","));
    }

    const text = data.join("\n");
    const blob = new Blob([text], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const onMonthChange = async (_, dateString) => {
    setLoading(true);
    setSelectedDateString(dateString);
    const split = dateString.split("-");
    const year = parseInt(split[0]);
    const month = parseInt(split[1]);
    const data = await Util.sendGet(
      "/api/moresheetStaff/getFinalizedMonthlyPay",
      {
        year,
        month,
      }
    );
    if (!data.success) {
      setLoading(false);
      setShowTables(true);
      messageApi.error("มีข้อผิดพลาด กรุณาลองใหม่ภายหลัง");
      return;
    }

    const payments = data.payments;

    // Branch
    const branchTableEntries = [];
    const storeGroup = {};
    for (const pay of payments) {
      if (!storeGroup.hasOwnProperty(pay.store)) {
        storeGroup[pay.store] = 0;
      }
      storeGroup[pay.store] += pay.total;
    }
    const stores = data.relaventStores;
    for (const st of stores) {
      if (!storeGroup.hasOwnProperty(st.code)) continue;

      branchTableEntries.push({
        code: st.code,
        name: `${st.name[0]} - ${st.name[1]}`,
        total: storeGroup[st.code],
      });
    }
    branchTableEntries.sort((a, b) => a.code - b.code);
    setBranchTable(branchTableEntries);

    // Group by facebookID
    const facebookIDGroup = {}; // 100% revenue, need to calculate 60%
    for (const pay of payments) {
      if (!facebookIDGroup.hasOwnProperty(pay.author)) {
        facebookIDGroup[pay.author] = 0;
      }
      facebookIDGroup[pay.author] += pay.total;
    }
    // Group by Vendor ID / slit those without
    const sellers = data.relaventSellers;
    const noVendorIdTable = [];
    const vendorIdGroup = {};
    const vendorIdValidTable = [];
    const vendorIdLessThan100Table = [];
    for (const seller of sellers) {
      if (!facebookIDGroup.hasOwnProperty(seller.facebookID)) continue;
      const total = facebookIDGroup[seller.facebookID];

      if (!seller.htiVendorId) {
        noVendorIdTable.push({
          codeName: seller.codeName,
          peopleID: seller.peopleID,
          realName: seller.realName,
          revenue: total.toFixed(2),
          total,
          payout: (0.6 * total).toFixed(2),
        });
        continue;
      }

      const splitBank = seller.bankInfo.split(",");
      const payBank = splitBank.length === 2 ? splitBank[0] : "Invalid";
      if (!vendorIdGroup.hasOwnProperty(seller.htiVendorId)) {
        vendorIdGroup[seller.htiVendorId] = {
          total: 0,
          htiVendorName: seller.htiVendorName,
          peopleID: seller.peopleID,
          realName: seller.realName,
          payBank,
        };
      }
      vendorIdGroup[seller.htiVendorId].total += total;
    }

    // Split into <100 and >100
    Object.entries(vendorIdGroup).map(([key, val]) => {
      const payout = val.total * 0.6;
      if (payout < 100) {
        vendorIdLessThan100Table.push({
          ...val,
          htiVendorId: key,
          payout: payout.toFixed(2),
          total: val.total.toFixed(2),
          scbNonScb: val.payBank === "ธ. ไทยพาณิชย์" ? "SCB" : "Non-SCB",
        });
      } else {
        vendorIdValidTable.push({
          ...val,
          htiVendorId: key,
          payout: payout.toFixed(2),
          total: val.total.toFixed(2),
          scbNonScb: val.payBank === "ธ. ไทยพาณิชย์" ? "SCB" : "Non-SCB",
        });
      }
      return null;
    });
    setLessHundredTable(vendorIdLessThan100Table);
    setMoreHundredTable(vendorIdValidTable);
    setNoVendorTable(noVendorIdTable);

    setLoading(false);
    setShowTables(true);
  };

  const Vendor = () => {
    const validVendorColumns = [
      {
        title: "Vendor Id",
        dataIndex: "htiVendorId",
        key: "htiVendorId",
      },
      {
        title: "Vendor Name",
        dataIndex: "htiVendorName",
        key: "htiVendorName",
      },
      {
        title: "เลขบัตรประชาชน",
        dataIndex: "peopleID",
        key: "peopleID",
      },
      {
        title: "ชื่อจริง",
        dataIndex: "realName",
        key: "realName",
      },
      {
        title: "ยอดขาย",
        dataIndex: "total",
        key: "total",
      },
      {
        title: "ยอดจ่าย(60%)",
        dataIndex: "payout",
        key: "payout",
      },
      {
        title: "ธนาคาร",
        dataIndex: "payBank",
        key: "payBank",
      },
      {
        title: "SCB or Non-SCB",
        dataIndex: "scbNonScb",
        key: "scbNonScb",
      },
    ];
    const noVendorColumns = [
      {
        title: "นามปากกา",
        dataIndex: "codeName",
        key: "codeName",
      },
      {
        title: "เลขบัตรประชาชน",
        dataIndex: "peopleID",
        key: "peopleID",
      },
      {
        title: "ชื่อจริง",
        dataIndex: "realName",
        key: "realName",
      },
      {
        title: "ยอดขาย",
        dataIndex: "total",
        key: "total",
      },
      {
        title: "ยอดจ่าย(60%)",
        dataIndex: "payout",
        key: "payout",
      },
    ];

    return (
      <React.Fragment>
        <Title level={4} type="success">
          มี Vendor ID และรายได้(60%)มากกว่า 100 บาท
        </Title>
        <Button
          type="primary"
          size="large"
          onClick={() =>
            downloadAsCsv(
              moreHundredTable,
              validVendorColumns,
              `payable_${selectedDateString}.csv`
            )
          }
        >
          Download as CSV
        </Button>
        <Table
          dataSource={moreHundredTable}
          columns={validVendorColumns}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100", "200"],
          }}
        />
        <Title level={4} type="warning">
          มี Vendor ID และรายได้(60%)น้อยกว่า 100 บาท
        </Title>
        <Button
          type="primary"
          size="large"
          onClick={() =>
            downloadAsCsv(
              lessHundredTable,
              validVendorColumns,
              `lessthanhundred_${selectedDateString}.csv`
            )
          }
        >
          Download as CSV
        </Button>
        <Table
          dataSource={lessHundredTable}
          columns={validVendorColumns}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100", "200"],
          }}
        />
        <Title level={4} type="danger">
          ไม่มี Vendor ID
        </Title>
        <Button
          type="primary"
          size="large"
          onClick={() =>
            downloadAsCsv(
              noVendorTable,
              noVendorColumns,
              `novendor_${selectedDateString}.csv`
            )
          }
        >
          Download as CSV
        </Button>
        <Table
          dataSource={noVendorTable}
          columns={noVendorColumns}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100", "200"],
          }}
        />
      </React.Fragment>
    );
  };

  const Branch = () => {
    const BranchColumns = [
      {
        title: "Branch",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "ยอดขาย",
        dataIndex: "total",
        key: "total",
      },
    ];
    return (
      <React.Fragment>
        <Button
          type="primary"
          size="large"
          onClick={() =>
            downloadAsCsv(
              branchTable,
              BranchColumns,
              `branchdata_${selectedDateString}.csv`
            )
          }
        >
          Download as CSV
        </Button>
        <Table
          dataSource={branchTable}
          columns={BranchColumns}
          pagination={{
            pageSize: 100,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100", "200"],
          }}
        />
      </React.Fragment>
    );
  };

  const tabItems = [
    {
      key: "v1",
      label: "รายผู้ขาย",
      children: <Vendor />,
    },
    {
      key: "v2",
      label: "ราย Branch",
      children: <Branch />,
    },
  ];
  return (
    <Space direction="vertical" size={12}>
      {contextHolder}

      <DatePicker onChange={onMonthChange} picker="month" />
      {loading && <div>กำลังโหลดข้อมูล...</div>}
      {!loading && showTables && <Tabs defaultActiveKey="1" items={tabItems} />}
    </Space>
  );
}

export default Monthly;
